/* eslint-disable no-unused-vars */
import { h } from 'hyperapp'

export const HeaderView = () => (
  <header>
    <h2>todo app</h2>
    <p>
      <em>
        <small>tap text to edit todo
        </small>
      </em>
      <a href='https://github.com/marcusasplund/hyperapp-todo-simple/'>{' '}
        <small>source
        </small>
      </a>
    </p>
  </header>
)
